import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import type { UnverifiedWalletAccount } from '../unverifiedWalletAccounts.types';

type SetUnverifiedWalletAccountsParams = {
  unverifiedWalletAccountsToUpdate: UnverifiedWalletAccount[];
};

/**
 * Updates the unverified wallet account in the client state.
 * This will add new wallet accounts and override those with matching ids,
 * but will leave other preexisting wallet accounts unchanged.
 */
export const setUnverifiedWalletAccounts = (
  { unverifiedWalletAccountsToUpdate }: SetUnverifiedWalletAccountsParams,
  client: DynamicClient
): void => {
  if (unverifiedWalletAccountsToUpdate.length === 0) {
    return;
  }

  const core = getCore(client);

  const unverifiedWalletAccountsToUpdateIds =
    unverifiedWalletAccountsToUpdate.map(({ id }) => id);

  const filteredUnverifiedWalletAccounts: UnverifiedWalletAccount[] = core.state
    .get()
    .unverifiedWalletAccounts.filter(
      (unverifiedWalletAccount) =>
        !unverifiedWalletAccountsToUpdateIds.includes(
          unverifiedWalletAccount.id
        )
    );

  core.state.set({
    unverifiedWalletAccounts: [
      ...filteredUnverifiedWalletAccounts,
      ...unverifiedWalletAccountsToUpdate,
    ],
  });
};
